import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSystemAgentsList } from '@/service/systemControl';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {},
};

/**
 * 指挥中心「员工总数」：GET /system/agents/page 的 totalRow（state=1 等条件由 Page manual 拼装）。
 * axiosType 由 service 层合并；Redux 只落库。
 */
export const fetchCommandCenterStaffAgentsPage = createAsyncThunk(
  'commandCenterStaffAgentsPage/fetchCommandCenterStaffAgentsPage',
  async ({ query = {} }, { rejectWithValue }) => {
    const storeId = query?.storeId;
    if (storeId === undefined || storeId === null || String(storeId).trim() === '') {
      return { data: { totalRow: 0 }, query };
    }
    try {
      const response = await getSystemAgentsList(query);
      const body = response?.data && typeof response.data === 'object' ? response.data : {};
      const nested = body.data && typeof body.data === 'object' ? body.data : null;
      const totalRow = Number(body.totalRow ?? nested?.totalRow ?? 0) || 0;
      const records = Array.isArray(body.list)
        ? body.list
        : Array.isArray(body.records)
          ? body.records
          : Array.isArray(nested?.list)
            ? nested.list
            : (Array.isArray(nested?.records) ? nested.records : []);
      return { data: { totalRow, records }, query };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取员工分页统计失败');
    }
  },
);

const commandCenterStaffAgentsPageSlice = createSlice({
  name: 'commandCenterStaffAgentsPage',
  initialState: defaultState,
  reducers: {
    resetCommandCenterStaffAgentsPageState: () => defaultState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommandCenterStaffAgentsPage.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query ?? {};
      })
      .addCase(fetchCommandCenterStaffAgentsPage.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data ?? {};
        state.query = action.payload.query ?? {};
      })
      .addCase(fetchCommandCenterStaffAgentsPage.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  },
});

export const { resetCommandCenterStaffAgentsPageState } = commandCenterStaffAgentsPageSlice.actions;
export default commandCenterStaffAgentsPageSlice.reducer;
